interface ILevel {
  from: number;
  base: number;
  pct: number;
}

export const computeReward = (price: number) => {
  const levels: ILevel[] = [
    { from: 0, base: 0, pct: 15 },
    { from: 500000, base: 75000, pct: 9 },
    { from: 1000000, base: 120000, pct: 4 },
    { from: 5000000, base: 280000, pct: 3 },
    { from: 10000000, base: 430000, pct: 2 },
    { from: 50000000, base: 1230000, pct: 1 },
  ];

  let result = 0;

  levels.forEach((l) => {
    if (price >= l.from) {
      result = l.base + ((price - l.from) * l.pct) / 100;
      return;
    }
  });

  return result;
};

export const formatPrice = (price: number) => `${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} Kč`;
